import React, { useEffect, useRef, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import SingleBlog from "../../components/Blog";
import config from "../../config";
import makeRequest from "../../makeRequest";

import fallbackImg from "../../assets/img/blog/blog-1-1.jpg";

const BASE = config.api.baseUrl;

function BlogCard({ blog, delay }) {
  const [imgSrc, setImgSrc] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    if (!blog.hasImage1) return;
    let cancelled = false;
    fetch(`${BASE}/website/blog/${blog.id}/image/image1`)
      .then((r) => (r.ok ? r.blob() : null))
      .then((blob) => {
        if (blob && !cancelled) {
          const url = URL.createObjectURL(blob);
          ref.current = url;
          setImgSrc(url);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (ref.current) URL.revokeObjectURL(ref.current);
    };
  }, [blog.id, blog.hasImage1]);

  const date = blog.createdAt ? new Date(blog.createdAt) : new Date();
  const day = String(date.getDate());
  const month = date.toLocaleString("default", { month: "short", year: "2-digit" });

  return (
    <div className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay={delay}>
      <SingleBlog
        blogImage={imgSrc || fallbackImg}
        publishedDate={day}
        publishedMonth={month}
        authorName={blog.name || "Maroof"}
        title={blog.title || blog.name}
        btnText="Read More"
        blogId={blog.id}
      />
    </div>
  );
}

const BlogMain = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    makeRequest({ route: "/website/blog?noPagination=1&isActive=1", method: "get" })
      .then(({ data }) => {
        if (Array.isArray(data)) setBlogs(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const delays = [".3s", ".5s", ".7s"];

  return (
    <main>
      <Breadcrumb title="Blog" />

      <div className="it-blog-area fix pt-120 pb-90">
        <div className="container">
          {loading ? (
            <div style={{ textAlign: "center", padding: 80, color: "#6b7280" }}>
              <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: 36, color: "#076cec" }}></i>
            </div>
          ) : blogs.length === 0 ? (
            <div style={{ textAlign: "center", padding: 80, color: "#6b7280" }}>No blog posts available yet.</div>
          ) : (
            <div className="row">
              {blogs.map((b, i) => (
                <BlogCard key={b.id} blog={b} delay={delays[i % delays.length]} />
              ))}
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default BlogMain;
